<template>
  <div>
    <div :class="`team-panel ${this.color}`">
      <div class="team-panel-header">
        <h4>TIME <strong>{{teamName || "Sem Nome"}}</strong></h4>
      </div>
      <div class="team-panel-players">
        <div v-for="user in lobbyUsers" :key="user.id"  :class="{ 'player-box': true, 'leader': user.role == 'lobby-leader'}">
          <div class="player-info">
            <a :href="`/users/${user.to_param}`" target="_blank">
              {{user.nickname}}
            </a>
            <div class="actions">
              <a v-if="currentUserRole == 'lobby-leader'" v-on:click.prevent="swapTeam(user.id)">mudar de time</a>
              <a v-if="currentUserRole == 'lobby-leader' && currentUser.id != user.id" v-on:click.prevent="kickPlayer(user.id)">kick</a> 
              <span v-if="user.role == 'lobby-leader'">
                <i class="fas fa-crown" v-b-tooltip.hover title="admin da sala"></i>
              </span>
              <span v-if="user.role == 'team-leader'">
                <i class="fas fa-ribbon" v-b-tooltip.hover title="capitão do time"></i>
              </span>
            </div>
          </div>
          <div class="player-status">
            <span v-if="user.status == 'accepted'"><i class="fa fa-circle ready" v-b-tooltip.hover title="pronto para jogar"></i></span>
            <i class="fas fa-circle" v-else-if="user.status == 'idle'" v-b-tooltip.hover title="na sala, não pronto ainda"></i>
            <i class="far fa-circle" v-else v-b-tooltip.hover title="desconectado"></i>
          </div>
        </div>
      </div>
    </div>
    <!-- <a v-on:click.prevent="swapReady(user.id)" v-if="currentUser().id == user.id && user.status == 'idle'" class="button is-large is-primary">ready?</a> -->
  </div>
</template>

<script>
export default {
  props: ['lobbyUsers', 'teamName', 'currentUserRole', 'color'],
  data: function () {
    return {
    }
  },
  methods: {
    swapTeam (id) {
      this.$emit('swapTeam', { userId: id });
    },
    kickPlayer (id) {
      this.$emit('kickPlayer', { userId: id });
    },
    // currentUser () {
    //   // return { id: window.Pug.currentUserId, role: window.Pug.currentUserRole }
    //   // return this.$store.getters.user
    //   // window.Pug.currentUserRole
    //   return { id: this.$store.getters.user.id, role: 'lobby-leader' }
    // }
  },
  computed: {
    currentUser () {
      // 'lobby-leader'
      return  { id: this.$store.getters.user.id, role: this.$props.currentUserRole }
    }
  }
}
</script>

<style scoped lang="sass">
  $green: #62c462
  $blue: #008EB4
  .team-panel
    border: 1px solid rgba(255, 255, 255, 0.2)
    &.blue
      background: rgba($blue, .1)
    &.green
      background: rgba($green, .1)
    .team-panel-header
      padding: 10px
      background: rgba(0, 0, 0, .2)
      h4
        margin: 0
        font-size: 13px
        strong
          display: block
          font-size: 24px
    .team-panel-players
      .player-box
        display: flex
        background: rgba(0, 0, 0, .1)
        align-items: center
        &:not(:first-child)
          // border-top: 1px solid rgba(255, 255, 255, .4)
        &:not(:last-child)
          border-bottom: 1px solid rgba(255, 255, 255, .1)
        
        &.leader
          background: rgba(yellow, .2)

        .player-info
          padding: 5px 10px
          flex: 1
          a:hover
            font-weight: bold
          .actions
            display: block
            font-size: 12px
            a
              &:not(:last-child)
                margin-right: 10px
        .player-status
          flex: 0 1
          padding: 10px 12px
          border-left: 1px solid rgba(255, 255, 255, .1)

</style>
